// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let SiteV3Api = class SiteV3Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Get existing Contacts by Tenant and Parent identifiers.
     * @param parentId Parent identifier
     */
    async siteContactGetByTenantId(parentId) {
        const _url_ = '/site/v3/SiteContact/{parentId}'
            .replace('{' + 'parentId' + '}', encodeURIComponent(String(parentId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'parentId' is not null or undefined
        if (parentId === null || parentId === undefined) {
            throw new Error('Required parameter parentId was null or undefined when calling siteContactGetByTenantId.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteSharedContactModels");
        }
        return response;
    }
    /**
     *
     * @summary Get a Site
     * @param siteId Site identifier
     * @param roleType Role Type
     */
    async siteGetByTenantId(siteId, roleType) {
        const _url_ = '/site/v3/Site/{siteId}/{roleType}'
            .replace('{' + 'siteId' + '}', encodeURIComponent(String(siteId)))
            .replace('{' + 'roleType' + '}', encodeURIComponent(String(roleType)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'siteId' is not null or undefined
        if (siteId === null || siteId === undefined) {
            throw new Error('Required parameter siteId was null or undefined when calling siteGetByTenantId.');
        }
        // verify required parameter 'roleType' is not null or undefined
        if (roleType === null || roleType === undefined) {
            throw new Error('Required parameter roleType was null or undefined when calling siteGetByTenantId.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get a list of Sites by IDs
     * @param request_body List of Site identifiers
     */
    async siteListByTenantId(request_body) {
        const _url_ = '/site/v3/SiteList';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'request_body' is not null or undefined
        if (request_body === null || request_body === undefined) {
            throw new Error('Required parameter request_body was null or undefined when calling siteListByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(request_body, "Array<number>"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteModels");
        }
        return response;
    }
    /**
     *
     * @summary Search for Sites that match supplied criteria.  Note: External Ids are deprecated, use Global Ids.
     * @param SiteSearchRequestModel Search criteria
     */
    async siteSearchByTenantId(SiteSearchRequestModel) {
        const _url_ = '/site/v3/SiteSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SiteSearchRequestModel' is not null or undefined
        if (SiteSearchRequestModel === null || SiteSearchRequestModel === undefined) {
            throw new Error('Required parameter SiteSearchRequestModel was null or undefined when calling siteSearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SiteSearchRequestModel, "SiteSearchRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteSearchModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Search for Sites that match supplied criteria.  Note: External Ids are deprecated, use Global Ids.
     * @param UpsearchModelSiteSiteUpsearchModel Upsearch criteria
     */
    async siteUpsearchByTenantId(UpsearchModelSiteSiteUpsearchModel) {
        const _url_ = '/site/v3/SiteUpsearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UpsearchModelSiteSiteUpsearchModel' is not null or undefined
        if (UpsearchModelSiteSiteUpsearchModel === null || UpsearchModelSiteSiteUpsearchModel === undefined) {
            throw new Error('Required parameter UpsearchModelSiteSiteUpsearchModel was null or undefined when calling siteUpsearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UpsearchModelSiteSiteUpsearchModel, "UpsearchModelSiteSiteUpsearchModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteLongResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get a list of Sites associated with a Tenant and Prescriber identifiers.
     * @param prescriberId Prescriber identifier
     */
    async sitesByPrescriberGetByTenantId1(prescriberId) {
        const _url_ = '/site/v3/SitesByPrescriber/{prescriberId}'
            .replace('{' + 'prescriberId' + '}', encodeURIComponent(String(prescriberId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'prescriberId' is not null or undefined
        if (prescriberId === null || prescriberId === undefined) {
            throw new Error('Required parameter prescriberId was null or undefined when calling sitesByPrescriberGetByTenantId1.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteModels");
        }
        return response;
    }
};
SiteV3Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], SiteV3Api);
export { SiteV3Api };
//# sourceMappingURL=siteV3Api.js.map